/**
 * 附件信息
 */
export interface FileInfo {
  // 附件OssId,必填
  fileId: string;
  // 附件类型
  type: string;
  // 附件名称
  name: string;
  // 附件大小
  size: number;
  // 桶的key
  bizCode: string;
  // 下载文件的url
  url: string;
}

/**
 * 角色枚举：
 * 非本人，
 * 本人查看：1，
 * 审核人查看：2，
 * 审批人查看：3
 */
export enum USER_ROLE {
  NOT_SELF,
  SELF,
  FINANCE_AUDIT,
  LEADER_APPROVAL,
  ACCOMPANY,
}

export enum APPLY_FORM_TYPE {
  trip = 1,
  meeting,
  training,
  purchase,
  seal,
  reception,
  general,
  tender,
  common,
  services,
  furniture,
}

/**
 * 单据类型：申请单或者报销单
 */
export enum APPLY_CLAIM {
  APPLY = 1,
  CLAIM,
}

/**
 * 费用类型枚举
 */
export enum FeeTypeEnum {
  // 差旅-住宿
  TripHotel = '10',
  // 差旅-交通
  TripTraffic = '20',
  // 差旅-交通-自驾
  TripTraffic_selfDriving = '2007',
  // 差旅-伙食
  TripFood = '30',
  // 差旅-公杂
  TripMiscellaneous = '40',
  // 差旅-短途
  TripShortDistance = '50',
  // 会议-住宿
  MeetingHotel = '60',
  // 会议-伙食
  MeetingFood = '70',
  // 会议-其他
  MeetingOther = '80',
  // 培训-住宿
  TrainingHotel = '90',
  // 培训-伙食
  TrainingFood = '100',
  // 培训-场地
  TrainingIncidental = '110',
  // 培训-师资
  TrainingTeach = '120',
  // 培训-其他
  TrainingOther = '130',
  // 公务接待-工作餐费
  ReceptionMeal = '140',
  // 公务接待-其他
  ReceptionOther = '150',
  // 通用采购-默认分类
  Purchase = '160',
  // 办公用品-家具
  Furniture = '170',
  // 办公用品-设备
  Equipment = '180',
  // 夜餐费
  Overtime = '190',
}

export enum TravelTypeEnum {
  // 普通出差
  NormalTravel = 0,
  // 会议培训专项
  MeetingTraining = 1,
  // 外派
  OutAssign = 3,
}

export interface DrawerBaseProps {
  visible: boolean;
  onClose?: () => void;
  onOk?: (options?) => any;
}

export interface ModalBaseProps {
  visible: boolean;
  onCancel?: () => void;
  onOk?: (options?) => any;
}

export interface Contract {
  orderCode: string;
  orderCodeList: Array<string>;
  uniqueCode: string;
  contractId: number;
  contractCode: string;
  contractName: string;
  applyFormCode: string;
  expenseFormCode: string;
  amount: number;
  firstPartyName: string;
  firstPartyContact: string;
  firstPartyPhone: string;
  secondPartyName: string;
  secondPartyContact: string;
  secondPartyPhone: string;
  detail: string;
  remark: string;
  status: number; // 合同状态：0草稿 1被驳回 2用印申请中 3签订完成 4已作废
  statusDesc: string;
  dataSource: number; // 0手动添加 1政采云 3报销单
  attachment: Array<FileInfo>;
  stagingType: number;
  stagingContractList: Array<Object>;
  orderNo: string;
  supBankAccount: string;
  supBankAccountPlaintext: string;
  supBankName: string;
  supBankPerson: string;
  accountCode: string;
  expenseAmountRecordDTOS: Array<Object>;
  contractRemainingAmount: number;
}

export interface InvoiceDetail {
  originalUrl: string; // 原图地址
  invoiceCode: string; // 发票id
  dataSource: string; // 发票来源
}
// 政采云订单详情
export interface ZcyOrderDetail {
  payeeInfoList: Array<any>; // 结算单
  contractList: Array<Contract>; // 合同
  invoiceList: Array<InvoiceDetail>; // 发票
  orderCode: string; // 订单code
  applyFormCode: string; // 关联申请单code
  bussinessCode: string; // 业务单号
  realPrice: number;
  orderAmount: number;
  orderRemainingAmount: number;
}

export interface LicenseAccount {
  licenseCode: string;
  licenserOperatorId: number;
  licenserName: string;
  licenserOrgId: number;
  licenseeOperatorId: number;
  licenseeName: string;
  licenseeOrgName: string;
  licenseeDeptId: null;
  licenseeDeptName: string;
  validTime: number;
  validStatus: number;
}

/**
 * 关联组织来源
 */
export enum Source {
  ZLB = 1,
  ZZD = 2,
  DING_TALK = 5,
}

/**
 * 单位类型
 */
export enum CompanyType {
  /**
   * 治理端/租户侧
   */
  Tenant = '88',
  /**
   * 运营侧
   */
  Operation = '99',
  /**
   * 采购单位
   */
  Company = '01',
}

// 导入解析结果状态枚举
export enum IMPORT_STATUS {
  UnCompleted = 0,
  success = 1,
  fail = 2,
  partialFail = 3,
}
